import {map, filter} from 'rxjs/operators';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ITableHeader} from '../../../../shared/table/TableComponent';
import {BehaviorSubject, Observable} from 'rxjs';
import {AllocationReport} from '../../../../../services/api.client';
import {formatDate} from '../../../../../utilities/date-util';
import {formatCurrency} from '../../../../../utilities/Util';
import {SHORT_DATE_FORMAT} from '../../../../../constants';
import {User} from '../../../../../services/api.client';
import {PledgeReportForm} from '../../PledgeReportForm';
import {SecurityService} from '../../../../../services/SecurityService';

@Component({
    templateUrl: './AllocationAndBalancesComponent.html',
    standalone: false
})
export class AllocationAndBalancesComponent implements OnInit {
  tableHeaders: ITableHeader[] = [];
  rows: any;

  @ViewChild('form')
  form: PledgeReportForm;

  // subscription
  currentUser: User;
  currentUser$: Observable<User>;
  private readonly _report$ = new BehaviorSubject<AllocationReport[]>(null);
  report$: Observable<AllocationReport[]> = this._report$.asObservable();

  constructor(private _securityService: SecurityService) {
      this.currentUser$ = this._securityService.currentUser$;
  }

  submitReport(): void {
      this.form.submitAllocationAndBalanceReport()?.subscribe({next: (report) => this._report$.next(report), error: () => {}});
  }

  ngOnInit(): void {
      this.currentUser$.subscribe(user => this.currentUser = user);

      if (this.currentUser.hasPrivate) {
      this.tableHeaders = [
        {text: 'Agency Name', },
        {text: 'Allocation Note', },
        {text: 'Fund Type', },
        {text: 'Admin %', },
        {text: 'Allocated', },
        {text: 'Spent', },
        {text: 'Current Balance', },
        {text: 'Entered', },
        {text: 'Ledger #', },
        {text: 'Private', },
      ];

      this.rows = this.report$.pipe(
        filter(report => !!report),
        map((report) => report.map(r => [
          r.agencyName,
          r.note,
          r.fundType,
          r.adminPercent / 100,
          formatCurrency(r.allocated),
          formatCurrency(r.spent),
          formatCurrency(r.remainingBalance),
          formatDate(r.enteredDate, SHORT_DATE_FORMAT),
          r.ledgerNumber,
          r.isPrivate
        ])), );

    } else {
      this.tableHeaders = [
        {text: 'Agency Name', },
        {text: 'Allocation Note', },
        {text: 'Fund Type', },
        {text: 'Admin %', },
        {text: 'Allocated', },
        {text: 'Spent', },
        {text: 'Current Balance', },
        {text: 'Entered', },
        {text: 'Ledger #', },
      ];

      this.rows = this.report$.pipe(
        filter(report => !!report),
        map((report) => report.map(r => [
          r.agencyName,
          r.note,
          r.fundType,
          r.adminPercent / 100,
          formatCurrency(r.allocated),
          formatCurrency(r.spent),
          formatCurrency(r.remainingBalance),
          formatDate(r.enteredDate, SHORT_DATE_FORMAT),
          r.ledgerNumber
        ])), );
    }
  }
}
